<app-roster-roster-link [termCode]="termCode" [crn]="crn"></app-roster-roster-link>
<app-text [alias]="'upload_grade_page'"></app-text>
<input type="file" (change)="processFile($event)">

<div *ngIf="showCancelMessage">
    Upload grades has been cancelled.
</div>
<div *ngIf="fileColumnNames?.length === 0 && file">
    Please upload a file that contain column heading.
</div>
<div *ngIf="needToDisplaySelectHeader && fileColumnNames?.length > 0">
    <br>

    <div class="row">
        <div class="large-4  columns">
            Please select the column for SID/NetId.
        </div>
        <div class="large-2   columns">
            <select [(ngModel)]="selectedIDColumn" (change)="setPreview()">
                <option [value]=""></option>
                <option *ngFor="let columnName of fileColumnNames; let i = index"
                        [value]="i">{{columnName}}</option>
            </select>
        </div>
    </div>
    <div class="row">

        <div class="large-4 columns">
            Please select the column containing grades.
        </div>
        <div class="large-2 columns">
            <select [(ngModel)]="selectedIGradeColumn" (change)="setPreview()">
                <option [value]=""></option>
                <option *ngFor="let columnName of fileColumnNames; let i = index"
                        [value]="i">{{columnName}}</option>
            </select>
        </div>
    </div>
</div>

<div *ngIf="previewResult" class="row previewGradeResultUpload">
    <div class="large-4 small-12 columns">
        <div>
            Please ensure the preview below looks correct prior to uploading your roster.
        </div>
        <table>
            <thead>
            <tr>
                <td>SID/NetID</td>
                <td>Grades</td>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of fileContentJson | slice:0:numRecordPreview; let i=index">
                <td *ngIf="isIDSelected">
                    <div *ngIf="!item[fileColumnNames[selectedIDColumn]]">Header Row Not Imported</div>
                    <div *ngIf="item[fileColumnNames[selectedIDColumn]]">{{item[fileColumnNames[selectedIDColumn]] }}</div>

                </td>
                <td *ngIf="!isIDSelected"></td>
                <td *ngIf="isIGradeSelected">
                    {{item[fileColumnNames[selectedIGradeColumn]] }}
                </td>
                <td *ngIf="!isIGradeSelected"></td>
            </tr>
            </tbody>

        </table>
    </div>
    <!--- preview result if there are column selected -->
    <div *ngIf="isIDSelected && isIGradeSelected" class="large-8 small-12 columns">
        <app-text [alias]="'upload_grade_status_preview'" [interpolationObject]="gradeUploadStatData"></app-text>
        <app-button-list>
            Does the preview look correct?
            <app-button [icon]="'save'" (clickedEvent)="confirmUploadGrade()">Yes </app-button>
            <app-button [icon]="'cancel'" (clickedEvent)="cancelUploadGrade()">No </app-button>
        </app-button-list>
    </div>
</div>



<mat-accordion [multi]="true" *ngIf="studentListNeedConfirm?.length>0">
    <mat-panel-title>
        Incomplete Removals: ({{studentListNeedConfirm?.length}})
    </mat-panel-title>
    <mat-expansion-panel [expanded]="canExpand(list.student, list.statement)" *ngFor="let list of studentListNeedConfirm" >
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{list.student.studentId}} changing grade from {{list.oldGrade? list.oldGrade :'no grade'}} to {{list.newGrade}}
            </mat-panel-title>
            <mat-panel-description>
                Agree to statement? {{list.student.gradeResponse.agree?'Yes':'No'}}
            </mat-panel-description>
        </mat-expansion-panel-header>
        <app-roster-grade-statement-content [gradeStatement]="list.statement" [student]="list.student"></app-roster-grade-statement-content>
    </mat-expansion-panel>
</mat-accordion>
<app-button-list *ngIf="canSubmit(studentListNeedConfirm)">
    <app-button [icon]="'save'" (clickedEvent)="submitAgreeStudentList(studentListNeedConfirm)">Continue  </app-button>
</app-button-list>
